
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/component-inherit/index.js
// module id = xf82
// module chunks = 1